var map = {
	"./buffalo_za.jpg": 290,
	"./crane_zim.jpg": 291,
	"./cranes_zim_2.jpg": 292,
	"./elephant.jpg": 293,
	"./elephant_2.jpg": 294,
	"./fish_eagle.jpg": 295,
	"./fish_eagle_bots.jpg": 296,
	"./gamedrive.jpg": 40,
	"./giraffe_bots.jpg": 297,
	"./leopard.jpg": 298,
	"./lion.jpg": 299,
	"./ostrich.jpg": 300,
	"./rhino.jpg": 301,
	"./roller_zim.jpg": 302,
	"./village.jpg": 303,
	"./zebras.jpg": 304
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	return map[req] || (function() { throw new Error("Cannot find module '" + req + "'.") }());
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 347;



//////////////////
// WEBPACK FOOTER
// ./src/assets/img/stock/botswana nonrecursive \.(png|jpe?g|svg)$
// module id = 347
// module chunks = 0